import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Eyebrow } from './Eyebrow';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-2.5rem)] items-center bg-brand-main px-5 py-6 md:py-10" data-id="element-80" data-mp="2hsq7unt4r3ou">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-[1100px] flex-col items-center text-center" data-id="element-81" data-mp="28tmkh7mxk24j">
        <Eyebrow data-id="element-82" data-mp="30nevnxor2xgs">Das komplette Musik-Curriculum</Eyebrow>
        <h1 className="mt-3 max-w-3xl text-[1.75rem] font-extrabold leading-[1.1] tracking-tight text-brand-navy sm:text-[2.4rem] md:text-[3rem]" data-id="element-83" data-mp="2msunycq4lwej">
          Unterrichte ein ganzes Jahr{' '}
          <span className="italic text-brand-orange" data-id="element-84" data-mp="3fibbavyw2n3w">Musik</span> in nur 5
          Minuten Vorbereitung
        </h1>
        <p className="mx-auto mt-3 max-w-2xl text-[13px] leading-relaxed text-brand-gray sm:text-[15px]" data-id="element-85" data-mp="3ka35rhl61czb">
          Musik Startklar ist ein komplettes, fertiges Musik-Curriculum – 10
          Bände voller sofort einsetzbarer Stunden, Lehrer-Skripte zum Vorlesen
          und Bildfolgen Schritt für Schritt, von Klasse 1 bis Klasse 10. Kein
          Instrument nötig. Einfach ausdrucken und loslegen.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/6zndz9BTiSWv2VfyP9kYpw/ChatGPT_Image_15_sept_2026,_16_56_56.png" alt="Das Musik-Startklar-Komplettpaket mit 10 Bänden von Klasse 1 bis 10, digitalen Materialien und 6 Bonus-Heften" className="mx-auto my-4 h-[26svh] w-auto max-w-full object-contain sm:my-6 sm:h-[32svh]" data-id="element-86" data-mp="2kd23fv7cxgzx" />
        <CTAButton className="px-8 py-3.5" data-id="element-87" data-mp="334uvnnelqy6l" />
        <p className="mt-3 text-[11px] text-brand-gray sm:text-xs" data-id="element-88" data-mp="33307m081apya">
          Sofort-Download <span className="px-1" data-id="element-89" data-mp="1dqokyybg0mnv">·</span> Sichere Bezahlung{' '}
          <span className="px-1" data-id="element-90" data-mp="18rv7v702ixo8">·</span> 30 Tage Geld-zurück-Garantie
        </p>
      </motion.div>
    </section>;
}